import React, { useEffect } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { ChallanPDF } from "./ChallanPDF";
import { X } from "lucide-react";

interface ChallanPreviewModalProps {
  order: any;
  isOpen: boolean;
  onClose: () => void;
}

const ChallanPreviewModal: React.FC<ChallanPreviewModalProps> = ({
  order,
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen && order) {
      // Store the original title
      const originalTitle = document.title;
      // Set title to the desired filename
      document.title = `Challan-${order.orderNumber}`;

      // Restore the original title when modal closes
      return () => {
        document.title = originalTitle;
      };
    }
  }, [isOpen, order]);

  if (!isOpen || !order) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-[95vw] max-w-7xl h-[95vh] rounded-xl overflow-hidden flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 border-b flex justify-between items-center bg-white shrink-0">
          <div className="flex flex-col">
            <h3 className="font-bold text-slate-800 text-lg">
              Delivery Challan Preview
            </h3>
            <p className="text-xs text-slate-500 font-medium">
              Order Number: #{order.orderNumber}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400 hover:text-slate-600"
          >
            <X size={24} />
          </button>
        </div>
        <div className="flex-1 bg-slate-100 p-2 md:p-6 overflow-hidden">
          <PDFViewer
            width="100%"
            height="100%"
            className="rounded-lg shadow-2xl border border-slate-300"
          >
            <ChallanPDF order={order} />
          </PDFViewer>
        </div>
      </div>
    </div>
  );
};

export default ChallanPreviewModal;
